<template>
    <div id="main">
        <div class="barcode_top top_barcode"></div>
        <div class="barcode_title">{{$t('enterBarCode.EnterName')}}</div>
        <div class="name_input">
            <input autofocus="autofocus" v-model="customerName" type="text" class="code_input">
            <div class="close" @click="cleanInput('NAME')"><span></span></div>
        </div>
        <div class="barcode_title" style="margin-top: 40px;">{{$t('enterBarCode.EnterID')}}</div>
        <div class="id_input">
            <input v-model="customerID" type="text" class="code_input">
            <div class="close" @click="cleanInput('ID')"><span></span></div>
        </div>
        <div class="barcode_msg">
            <!-- <div class="first">(If barcode not correct)</div>
            <div>(If order is not belongs to to pickup point)</div>
            <div>(If order is not belongs to the selected logistics company)</div> -->
        </div>
        <button class="details_bt_w" @click="back()">{{$t('common.Back')}}</button>
        <button class="details_bt_b" @click="tiaoZhuan()">{{$t('common.Confirm')}}</button>
        <div class="curtain" v-if="showCurtain"></div>
        <div class="popup-msg" v-if="showCurtain">
            <div class="popup-msg-text">The order of this PIN code is not belongs to this pickup point. It should be at
                {location name}
            </div>
            <button class="try-again">Try again</button>
        </div>
        <transition name="tipMsg">
            <div class="tip-msg" v-if="showTip">
                {{tipMsg}}
            </div>
        </transition>
    </div>
</template>

<script>
import CryptoJS from 'crypto-js'
export default {
  name: 'EnterIdentity',
  data () {
    return {
      action: null,
      pin: null,
      expressNumber: null,
      customerName: null,
      customerID: null,
      showCurtain: false,
      showTip: false,
      tipMsg: null
    }
  },
  beforeCreate: function () {
    document.getElementsByTagName('body')[0].style = 'background-color: #f8f8f8;'
  },
  mounted () {
    this.action = this.$route.query.action
    this.pin = this.$route.query.pin
    this.expressNumber = this.$route.query.expressNumber
    // 解决手机端无法自动聚焦
    $('input[autofocus="autofocus"]').focus()
    // const key = 'ta4e4llss.4lp:pc'
    let key = CryptoJS.enc.Utf8.parse('ta4e4llss.4lp:pc')
    const et = CryptoJS.AES.encrypt('00000000272', key, {
      // drop: 128,
      iv: [],
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }
    )
    const etText = et.toString()
    const ciphertext = et.ciphertext.toString()
    const dt = CryptoJS.AES.decrypt(et.ciphertext.toString(CryptoJS.enc.Base64), key, {
      // drop: 128,
      iv: [],
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    })
    const dtText = dt.toString(CryptoJS.enc.Utf8)
    console.log('encrypted', et, etText)
    console.log('encrypted ciphertext', ciphertext, et.ciphertext.toString(CryptoJS.enc.Base64))
    console.log('decrypted', dt, dtText)
  },
  methods: {
    cleanInput (field) {
      if (field.includes('NAME')) {
        this.customerName = null
      }
      if (field.includes('ID')) {
        this.customerID = null
      }
    },
    tiaoZhuan () {
      console.log('tiaoZhuan ' + this.action)
      const vue = this
      switch (this.action) {
        case 'parcelInfo':
          break
        case 'collectingPointStoreExpress':
          break
        case 'collectingPointTakeExpress':
          vue.takeExpress()
          break
        case 'merchantTakeExpress':
          break
        case 'collectExpiredExpress':
          break
        default:
          vue.displayTip('unknow')
          break
      }
      return false
    },
    verifyCustomer () {
      var vue = this
      let queryNumber = vue.$route.query.expressNumber
      let pin = vue.$route.query.pin
      let customerName = vue.customerName
      let customerID = vue.customerID
      if (queryNumber !== vue.expressNumber) {
        vue.displayTip(vue.$t('barCode.mismatch'))
        return false
      }

      this.axios({
        method: 'post',
        url: vue.api.verifyCustomer,
        data: {
          expressNumber: vue.expressNumber,
          pinCode: pin,
          name: customerName,
          id: customerID
        }
      }).then(function (response) {
        // let ordersId = response.data.ordersId
        let message = 'CollectSuccess'
        vue.takeExpress()
      }).catch(function (error) {
        if (error.data.message) {
          vue.displayTip(error.data.message)
        } else {
          vue.displayTip(error)
        }
      })
    },
    takeExpress () {
      let vue = this
      let queryNumber = vue.$route.query.expressNumber
      if (queryNumber !== vue.expressNumber) {
        vue.displayTip(vue.$t('barCode.mismatch'))
        return false
      }

      let key = CryptoJS.enc.Utf8.parse('ta4e4llss.4lp:pc')
      const recipientNameEt = CryptoJS.AES.encrypt(vue.customerName, key, {
        // drop: 128,
        iv: [],
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      }
      )
      // const recipientNameEtText = recipientNameEt.toString()
      const recipientNameCiphertext = recipientNameEt.ciphertext.toString()

      const recipientIdNumberEt = CryptoJS.AES.encrypt(vue.customerID, key, {
        // drop: 128,
        iv: [],
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      }
      )
      // const recipientIdNumberEtText = recipientIdNumberEt.toString()
      const recipientIdNumberCiphertext = recipientIdNumberEt.ciphertext.toString()

      // alert('recipientNameCiphertext: ' + recipientNameCiphertext)
      // alert('recipientIdNumberCiphertext: ' + recipientIdNumberCiphertext)

      vue.axios({
        method: 'post',
        url: vue.api.collectingPointTakeExpress,
        data: {
          expressNumber: vue.expressNumber,
          pinCode: vue.pin,
          type: 'FOR_CUSTOMER_TAKE',
          recipientName: recipientNameCiphertext,
          recipientIdNumber: recipientIdNumberCiphertext
        }
      }).then(function (response) {
        // let ordersId = response.data.ordersId
        let message = 'CollectSuccess'
        vue.$router.push('/return/success?msg=' + message + '&action=collectingPointTakeExpress')
      }).catch(function (error) {
        if (error.data.message) {
          vue.displayTip(error.data.message)
        } else {
          vue.displayTip(error)
        }
      })
    },
    back () {
      this.$router.go(-1)
    },
    displayTip (msg = null) {
      let vue = this
      this.showTip = true
      this.tipMsg = msg
      setTimeout(function () {
        vue.showTip = false
        vue.tipMsg = null
      }, 2000)
    }
  }
}
</script>

<style lang="less" src="../../assets/css/return/entercode.css" scoped>
</style>
<style lang="less" scoped>
    .barcode_title {
      height: unset;
      min-height: 0.48rem;
    }

    .name_input, .id_input {
        margin: 0 auto;
        margin-top: 0.225rem;
        background: #FFFFFF;
        width: 3.525rem;
        height: 0.745rem;
        box-shadow: 0rem 0rem 0.1rem rgba(0, 0, 0, 0.16);
        border-radius: 0.1rem;
        display: flex;
        position: relative;
        z-index: 1;

        .code_input {
            border: none;
            color: #707070;
            height: 0.385rem;
            line-height: 0.385rem;
            font-size: 0.35rem;
            font-weight: 900;
            width: 3.01rem;
            margin-top: 0.185rem;
            margin-left: 0.205rem;
        }

        .close {
            position: absolute;
            z-index: 1;
            right: 0.07rem;
            top: 0.27rem;
            width: 0.21rem;
            height: 0.21rem;
            background: #D6D6D6;
            border-radius: 50%;
        }

        .close:before, .close:after {
            position: absolute;
            left: 0.093rem;
            top: 0.032rem;
            content: ' ';
            height: 0.14rem;
            width: 2px;
            background-color: #FFFFFF;
        }

        .close:before {
            transform: rotate(45deg);
        }

        .close:after {
            transform: rotate(-45deg);
        }
    }

    .barcode_msg {
        width: 3.525rem;
        height: 0.965rem;
        margin: 0 auto;
        margin-top: 0.13rem;

        div {
            max-width: 0.94rem;
            font-size: 0.09rem;
            font-weight: 900;
            line-height: 0.125rem;
            background: #FFFFFF;
            color: #FF0000;
            border: 1px solid #707070;
            float: left;
            margin-left: 0.14rem;
            padding: 0.075rem 0.055rem;
        }

        .first {
            margin-left: 0;
        }
    }

    .curtain {
        z-index: 2;
        height: 100%;
        width: 100%;
        background: #0f0f0f;
        opacity: 50%;
        position: fixed;
        top: 0;
        left: 0;
    }

    .popup-msg {
        z-index: 3;
        position: fixed;
        width: 94%;
        left: 3%;
        top: 30%;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.16);
        border-radius: 0.1rem;
    }

    .popup-msg-text {
        margin-top: 0.2rem;
        text-align: center;
        padding-left: 10%;
        padding-right: 10%;
        font-size: 0.15rem;
        margin-bottom: 0.1rem;
    }

    .try-again {
        width: 82%;
        height: 0.58rem;
        background: linear-gradient(113deg, #052460 0%, #1f9dc5 100%);
        -webkit-box-shadow: 0rem 0.05rem 0.1rem rgba(5, 36, 96, 0.3);
        box-shadow: 0rem 0.05rem 0.1rem rgba(5, 36, 96, 0.3);
        border-radius: 0.42rem;
        margin: 0.1rem 9% 0;
        border: none;
        color: #ffffff;
        line-height: 0.235rem;
        font-size: 0.2rem;
        font-weight: bold;
        margin-bottom: 0.2rem;
    }

    // .tip-msg {
    //     z-index: 3;
    //     position: fixed;
    //     top: 0.1rem;
    //     width: 90%;
    //     margin-left: 2%;
    //     background: rgba(255, 0, 0, 0.4);
    //     border-radius: 0.05rem;
    //     color: #fff;
    //     font-weight: 400;
    //     padding: 0.1rem;
    //     font-size: 0.15rem;
    //     text-align: center;
    //     max-width: 400px;
    // }

    // /*vue 动画CSS*/
    // .tipMsg-enter-active, .tipMsg-leave-active {
    //     transition: opacity .5s;
    // }

    // .tipMsg-enter, .tipMsg-leave-to /* .fade-leave-active below version 2.1.8 */ {
    //     opacity: 0;
    // }
</style>



// WEBPACK FOOTER //
// src/components/Return/EnterIdentity.vue